import axios from 'axios';
import { Dispatch } from 'react';
import {
    GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_REQUEST,
    GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_SUCCESS,
    GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_FAILURE,
    CLEAR_VENDOR_APPOINTMENTS_STATE,
} from '../constants/vendorAppointments.constant';
import { AnyIfEmpty } from 'react-redux';

// Interface for vendor appointment data
export interface VendorAppointment {
    id: string;
    accessCode: string;
    appointmentId: string;
    vendorName: string;
    vendorEmail: string;
    vendorPhone: string;
    appointmentDate: string;
    startTime: string;
    endTime: string;
    status: 'scheduled' | 'in-progress' | 'completed' | 'cancelled';
    locationId: string;
    locationName: string;
    unitNumber?: string;
    specialInstructions?: string;
    createdAt: string;
    updatedAt: string;
}

// Interface for API response
export interface VendorAppointmentsResponse {
    statusCode: number;
    message: string;
    appointments: VendorAppointment[];
    totalCount: number;
}

// Interface for access code request parameters
export interface GetVendorAppointmentsByAccessCodeParams {
    accessCode: string;
    locationId: string;
}

// Action creators
const getVendorAppointmentsByAccessCodeRequest = () => {
    return {
        type: GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_REQUEST,
    };
};

const getVendorAppointmentsByAccessCodeSuccess = (appointments: VendorAppointment[]) => {
    return {
        type: GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_SUCCESS,
        payload: appointments,
    };
};

const getVendorAppointmentsByAccessCodeFailure = (error: string) => {
    return {
        type: GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_FAILURE,
        payload: error,
    };
};

const clearVendorAppointmentsStateAction = () => {
    return {
        type: CLEAR_VENDOR_APPOINTMENTS_STATE,
    };
};

// Main action to fetch vendor appointments by access code
export const getVendorAppointmentsByAccessCode = (params: GetVendorAppointmentsByAccessCodeParams) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getVendorAppointmentsByAccessCodeRequest());

        axios
            .get(`/vendor-visit/find-by-location-access/${params.locationId}/${params.accessCode}`)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    // Handle successful response
                    const token = response?.data?.vendor?.token;
                    if (typeof window !== 'undefined' && token && response?.data?.vendor?.appointmentId) {
                        localStorage.setItem('vendorAccessToken', token);
                    }
                    const appointments = response?.data?.vendor;
                    dispatch(getVendorAppointmentsByAccessCodeSuccess(appointments));
                } else {
                    console.error('Error fetching vendor appointments:', response?.data?.message);
                    dispatch(getVendorAppointmentsByAccessCodeFailure(response?.data?.message || 'Failed to fetch vendor appointments'));
                }
            })
            .catch((error) => {
                // Handle network or other errors
                const errorMessage = error?.response?.data?.message || error?.message || 'Network error occurred';
                dispatch(getVendorAppointmentsByAccessCodeFailure(errorMessage));
            });
    };
};

// Action to clear vendor appointments state
export const clearVendorAppointmentsState = () => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(clearVendorAppointmentsStateAction());
    };
};
